import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=27cec49a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=27cec49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cec49a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cec49a')) {
      api.createRecord('27cec49a', component.options)
    } else {
      api.reload('27cec49a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=27cec49a&scoped=true&", function () {
      api.rerender('27cec49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21g3Gvq3imkY8/JS/comp/PopupBox.vue"
export default component.exports